"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var PhrasePill_1 = require("./PhrasePill");
var addPhraseToClause_1 = require("../actions/helpers/addPhraseToClause");
var removePhraseFromClause_1 = require("../actions/helpers/removePhraseFromClause");
var setClauseErrorText_1 = require("../actions/helpers/setClauseErrorText");
var setIncludesWordsInputText_1 = require("../actions/helpers/setIncludesWordsInputText");
var store_1 = require("../store/store");
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var KeyboardCharCodes_1 = require("owa-mail-hotkeys/lib/utils/KeyboardCharCodes");
var React = require("react");
var styles = require('./IncludesWordsInput.scss');
var classNames = require('classnames/bind').bind(styles);
var IncludesWordsInputComputedState = /** @class */ (function () {
    function IncludesWordsInputComputedState(props) {
        this.props = props;
    }
    Object.defineProperty(IncludesWordsInputComputedState.prototype, "isFocused", {
        get: function () {
            return store_1.default.inboxRulesEditState.focusedClauseId == this.props.clauseId;
        },
        enumerable: true,
        configurable: true
    });
    tslib_1.__decorate([
        mobx_1.computed
    ], IncludesWordsInputComputedState.prototype, "isFocused", null);
    return IncludesWordsInputComputedState;
}());
var IncludesWordsInput = /** @class */ (function (_super) {
    tslib_1.__extends(IncludesWordsInput, _super);
    function IncludesWordsInput(props) {
        var _this = _super.call(this, props) || this;
        _this.onInputChange = function () {
            setIncludesWordsInputText_1.default(_this.props.clauseId, _this.inputRef.value);
        };
        _this.onKeyDown = function (evt) {
            var clauseId = _this.props.clauseId;
            var inputText = store_1.default.inboxRulesEditState.includesWordsInputTextMap.get(clauseId);
            switch (evt.keyCode) {
                case KeyboardCharCodes_1.ENTER_CHARCODE:
                    evt.stopPropagation();
                    if (_this.isValidInput(inputText)) {
                        // clear the error text in case the user is creating their first pill while the error state is shown
                        setClauseErrorText_1.default(clauseId, true /*isValidClause*/);
                        addPhraseToClause_1.default(clauseId, inputText, 'Keyboard');
                    }
                    break;
                case KeyboardCharCodes_1.BACKSPACE_CHARCODE:
                    evt.stopPropagation();
                    if (!inputText) {
                        _this.removeLastPhraseFromClause(clauseId, inputText);
                    }
                    break;
            }
        };
        _this.onBlur = function () {
            var inputText = store_1.default.inboxRulesEditState.includesWordsInputTextMap.get(_this.props.clauseId);
            if (_this.isValidInput(inputText)) {
                addPhraseToClause_1.default(_this.props.clauseId, inputText, 'Blur');
            }
            _this.props.onBlur();
        };
        _this.computedState = new IncludesWordsInputComputedState(_this.props);
        return _this;
    }
    IncludesWordsInput.prototype.render = function () {
        var _this = this;
        var clauseId = this.props.clauseId;
        var selectedClause = store_1.default.inboxRulesEditState.clauseMap.get(clauseId);
        var errorText = store_1.default.inboxRulesEditState.clauseErrorTextMap.get(clauseId);
        var committedPhrases = selectedClause.clauseValue;
        var inputContainerClassName = classNames(styles.includesWordsInputContainer, this.computedState.isFocused && styles.inputFocused, errorText && styles.hasError);
        return (React.createElement("div", { className: styles.includesWordsContainer },
            React.createElement("div", { className: inputContainerClassName },
                this.renderCommittedPhrases(committedPhrases),
                React.createElement("input", { ref: function (ref) { return (_this.inputRef = ref); }, onFocus: this.props.onFocus, onBlur: this.onBlur, className: styles.phraseInput, value: store_1.default.inboxRulesEditState.includesWordsInputTextMap.get(clauseId), placeholder: committedPhrases.length > 0 ? '' : this.props.placeHolderText, onChange: this.onInputChange, onKeyDown: this.onKeyDown })),
            store_1.default.inboxRulesEditState.clauseErrorTextMap.get(clauseId) && (React.createElement("span", { className: styles.invalidInput }, errorText))));
    };
    IncludesWordsInput.prototype.renderCommittedPhrases = function (committedPhrases) {
        var _this = this;
        var phrasePills = [];
        if (committedPhrases.length > 0) {
            committedPhrases.forEach(function (phrase) {
                phrasePills.push(React.createElement(PhrasePill_1.default, { key: phrase, clauseId: _this.props.clauseId, phrase: phrase }));
            });
        }
        return phrasePills;
    };
    IncludesWordsInput.prototype.isValidInput = function (inputText) {
        // if user presses enter with empty input or only whitespace, input is invalid
        return inputText && inputText.trim().length > 0;
    };
    IncludesWordsInput.prototype.removeLastPhraseFromClause = function (clauseId, phrase) {
        var existingPhrases = store_1.default.inboxRulesEditState.clauseMap.get(clauseId)
            .clauseValue;
        // if there are no phrases to delete (if a user presses backspace on an empty input), do nothing
        if (!existingPhrases || existingPhrases.length == 0) {
            return;
        }
        removePhraseFromClause_1.default(this.props.clauseId, existingPhrases[existingPhrases.length - 1]);
    };
    IncludesWordsInput = tslib_1.__decorate([
        mobx_react_1.observer
    ], IncludesWordsInput);
    return IncludesWordsInput;
}(React.Component));
exports.default = IncludesWordsInput;
//# sourceMappingURL=IncludesWordsInput.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-inbox-rules-option/lib/components/IncludesWordsInput.js
// module id = 5189
// module chunks = 2